import '~/js/modules/tabs';
import '~/js/modules/stickyNav';
import ReactDOM from 'react-dom';
import ScubaCourses from '~/js/components/scuba/ScubaCourses';

const tabsBlock = document.querySelector('.tabs-macro');
const btnInfo = document.querySelector('.info__btn');
const coursesTitle = document.querySelector('.courses__select-title');
//const linkToPadiLearning = document.querySelector('.courses-top__block-link');

// scrolling to tabs
function scrollToTabs(toElem) {
  const posY = Math.round(toElem.getBoundingClientRect().top + window.pageYOffset);
  const isSmoothScrollSupported = 'scrollBehavior' in document.documentElement.style;

  if(isSmoothScrollSupported) {
    if (window.innerWidth < 768) {
      window.scrollTo({
        top: posY - 100,
        behavior: 'smooth'
      });

      return;
    }
    window.scrollTo({
      top: posY - 150,
      behavior: 'smooth'
    });
  } else {
    if (window.innerWidth < 768) {
      window.scrollTo(0, posY - 100);

      return;
    }
    window.scrollTo(0, posY - 150);
  }

}

// scroll on button
/*linkToPadiLearning.addEventListener('click', () => {
  scrollToTabs(tabsBlock);
});*/

// event on button
btnInfo.addEventListener('click', () => {
  scrollToTabs(tabsBlock);
});

// event after load page
if (document.location.hash
  && !localStorage.getItem('rstCode')) {
  window.addEventListener('load', () => {
    scrollToTabs(tabsBlock);
  });
}

// event after back details
if (localStorage.getItem('rstCode')) {
  window.addEventListener('load', scrollToTabs(coursesTitle));
}

// Custom Select
class CustomSelect {
  constructor(idSelect, defaultText = 'Select') {
    this.select = document.querySelector(idSelect);
    this.options = document.querySelectorAll(`${idSelect} option`);
    this.defaultText = defaultText;

    this._createCustomSelectWrapper();
    this._events();
  }

  hiddenSelect = () => {
    this.select.setAttribute('hidden', 'hidden');
  }

  _createCustomOptions = (customSelect) => {
    for(const option of this.options) {
      const customOption = document.createElement('div');

      // copy attributes from options to custom options
      for(const attr of option.attributes) {
        if(attr.name === 'value') {
          customOption.setAttribute('data-value', attr.value);
        } else {
          customOption.setAttribute(attr.name, attr.value);
        }
        customOption.classList.add('custom-option');
      }
      customOption.innerHTML = option.innerHTML;
      customSelect.appendChild(customOption);
    }
  }

  // create custom button
  _createCustomBtn = (customSelectWrap) => {
    this.customSelectBtn = document.createElement('div');
    this.customSelectBtn.classList.add('custom-btn');
    this.customSelectBtn.innerHTML = this.defaultText;
    customSelectWrap.appendChild(this.customSelectBtn);
  }

  // create custom select
  _createCustomSelect = (customSelectWrap) => {
    this.customSelect = document.createElement('div');
    // copy attributes from select to custom select
    for(let i = 0; i < this.select.attributes.length; i++) {
      this.customSelect.setAttribute(this.select.attributes.item(i).name, this.select.attributes.item(i).value);
    }
    this.customSelect.classList.add('custom-select');
    // add options
    this._createCustomOptions(this.customSelect);
    customSelectWrap.appendChild(this.customSelect);
  }

  // create custom wrapper and add children
  _createCustomSelectWrapper = () => {
    const customSelectWrap = document.createElement('div');

    customSelectWrap.classList.add('custom-select-wrap');
    this._createCustomBtn(customSelectWrap);
    this._createCustomSelect(customSelectWrap);
    this.select.parentNode.appendChild(customSelectWrap);
    this.hiddenSelect();
  }

  // toggle select
  _toggleSelect = () => {
    this.customSelect.classList.toggle('custom-select--active');
  }

  // close select
  _closeSelect = e => {
    if(e.target !== this.customSelectBtn && !e.target.classList.contains('custom-option')) {
      this.customSelect.classList.remove('custom-select--active');
    }
  }

  // select options
  _selectOption = e => {
    const options = document.querySelectorAll('.custom-option');

    for(const option of options) {
      if(e.target === option) {
        this.customSelectBtn.innerHTML = option.innerHTML;
        this.didSelect(option, e);
      }
    }
    this.customSelect.classList.remove('custom-select--active');
  }

  didSelect = () => {
    return;
  }

  // events
  _events = () => {
    window.addEventListener('click', this._closeSelect);
    window.addEventListener('touchstart', this._closeSelect);
    this.customSelectBtn.addEventListener('click', this._toggleSelect);
    this.customSelect.addEventListener('click', e => this._selectOption(e));
  }


}

// 1 param - Id element, 2 param - default select text
const customSelect = new CustomSelect('#select-resorts', 'Where will you be staying?');

customSelect.didSelect = (option) => {
  document.location.href = option.dataset.link;
};

// React Component Scuba Courses
function renderReactComponent(data) {
  ReactDOM.render(<ScubaCourses arrCourses={data} />, document.querySelector('#scuba-courses'));
}

import GoFetch from '~/js/modules/fetch-wrapper.js';
const fetch = new GoFetch();

function addContentToPopup(content) {
  const offerDetailsPopup = document.querySelector('#offer-details-popup');
  const top = '<h4>offer details</h4>';
  const title = `<h3>${content.title}</h3>`;

  offerDetailsPopup.innerHTML = top + title + content.description;
}

fetch.post('/fetchPromotion/?promo_ids=109352', null)
  .then(response => addContentToPopup(response.data.promotions[0].promotion));


// fetch('//cdn.sandals.com/beaches/v12/images/scuba/courses/data.json')
fetch.get('/events/fetchScuba/')
  .then(resolve => {
    renderReactComponent(resolve.data.events);
  })
  .catch(error => console.log(error));
